import Vue from 'vue'
import Vuex from 'vuex'
import webSite from './modules/webSite'
import getters from './getter'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    webSite
  },
  getters
})

export default store